export function LivestreamViewerFrameOverlay() {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-10 overflow-hidden"
      aria-hidden
    >
      <div className="flex h-full w-full items-center justify-center">
        <div
          className="box-border shrink-0 border-2 border-white/80 shadow-[0_0_0_9999px_rgba(0,0,0,0.45)]"
          style={{
            aspectRatio: "9 / 16",
            width: "min(100cqw, calc(100cqh * 9 / 16))",
          }}
        />
      </div>
    </div>
  );
}
